import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main.vue'
import xhjs from '@/components/xhjs.vue'
import gzdt from '@/components/gzdt.vue'
import wxsy from '@/components/wxsy.vue'
import hyfw from '@/components/hyfw.vue'
import kjcg from '@/components/kjcg.vue'
import tthydw from '@/components/tthydw.vue'

Vue.use(Router);

const router = new Router({

  // mode: 'hash',

  base: process.env.BASE_URL,

  routes: [

    {

      path: '/',

      name: 'main',

      component: Main,


    },

    {

      path: '/xhjs',

      name: 'xhjs',

      component: xhjs,

    },
    {

      path: '/gzdt',

      name: 'gzdt',

      component: gzdt,


    },
    {
      path: '/wxsy',

      name: 'wxsy',

      component: wxsy,
    },
    {
      path: '/hyfw',
      name: 'hyfw',
      component: hyfw,
    },
    {
      path: '/kjcg',
      name: 'kjcg',
      component: kjcg,
    },

    {
      path: '/tthydw',
      name: 'tthydw',
      component: tthydw,
    }
  ]
});



export default router;

